import { connect } from 'react-redux';
import DepartmentsList from "./DepartmentsList";
import { getTranslation } from "../../../reducers/common/localization";
import {
    fetchGetDepartments,
    getDepartmentsData,
    loadingDepartments
} from "../../../reducers/organization/departments";
import { MODAL_ADD_DEPARTMENT, MODAL_REMOVE_DEPARTMENT, showModal } from "../../../reducers/common/activeModal";
import { setDepartmentId, getDepartmentId } from "../../../reducers/organization/department";
import {getOrgPermissions} from "../../../reducers/organization/organization";
import {resetSubmitForm} from '../../../reducers/common/submitForm';

const mapStateToProps = state => {
    return {
        departmentId: getDepartmentId(state),
        translation: getTranslation(state),
        loading: loadingDepartments(state),
        data: getDepartmentsData(state),
        orgPermissions: getOrgPermissions(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(setDepartmentId(null));
            dispatch(fetchGetDepartments());
        },
        onAddButtonClick: () => {
            dispatch(showModal({ modalKey: MODAL_ADD_DEPARTMENT }));
            dispatch(resetSubmitForm());
        },
        onDepartmentSelect: (id) => dispatch(setDepartmentId(id)),
        onDepartmentRemove: () => {
            dispatch(showModal({ modalKey: MODAL_REMOVE_DEPARTMENT }));
            dispatch(resetSubmitForm());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentsList);



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/departmentsList/DepartmentsList.container.js